import moment from 'moment-timezone';

export default () => {
    const dates = document.querySelectorAll(`.js-format-date`);

    if (!dates.length) {
        return;
    }

    dates.forEach((date) => {
        const uglyDate = date.innerHTML;
        const prettyDate = formatPostDate(uglyDate.trim());
        date.innerHTML = prettyDate;
        date.classList.add(`js-format-date-loaded`);
    });
};

/**
 * Calculate time from post publish at local time
 * @param {*} post
 * @returns
 */
const formatPostDate = (date) => {
    // if unix timestamp
    if (typeof date === 'number') {
        date = moment.unix(date);
    }
    // normalize date to phoenix time as that is wp backend timezone and some dates don't have timezome associated
    const phxDate = moment.tz(date, 'America/Phoenix');
    // console.log(phxDate);
    const phxDateToLocal = phxDate.local(); // phoenix date to local time
    // console.log(phxDateToLocal);
    const fromNow = phxDateToLocal.fromNow().replace('a day ago', '1 day ago'); // 5 hours ago, etc
    // console.log(fromNow);
    const currentLocalDate = moment().local(); // current local time

    // difference in hours between local time and phoenix time converted to local
    const diff = currentLocalDate.diff(phxDateToLocal, 'days');

    // if diff is less than 2 days use fromNow
    return diff < 2 ? fromNow : phxDateToLocal.format('LL');
};
